import { render, staticRenderFns } from "./UsersLeaveForm.vue?vue&type=template&id=5d2846e2&scoped=true&"
import script from "./UsersLeaveForm.vue?vue&type=script&lang=js&"
export * from "./UsersLeaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2846e2",
  null
  
)

export default component.exports